module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h2', {
    staticClass: "u"
  }, [_vm._v("\n    Редактировать подъезд\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "sub-nav"
  }, [_c('router-link', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "to": {
        name: 'block-details',
        params: {
          block_id: _vm.block.id
        }
      }
    }
  }, [_vm._v("← Назад к Деталям подъезда")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [(_vm.block.id) ? _c('a', {
    staticClass: "red",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteBlock.apply(null, arguments)
      }
    }
  }, [_vm._v("удалить подъезд")]) : _vm._e()]), _vm._v(" "), _c('block-edit-form', {
    attrs: {
      "block": _vm.block
    },
    on: {
      "after": _vm.handleAfter
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1604d953","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/block/BlockEdit.vue
// module id = 585
// module chunks = 0